export const STATUS = {
  'Em Processamento': {
    label: 'Em Processamento',
    style: 'warning-light',
    value: 0
  },
  'Integrado/Pronto para implantação': {
    label: 'Integrado',
    style: 'success-light',
    value: 1
  },
  Erro: {
    label: 'Erro',
    style: 'error-light',
    value: 2
  },
  Finalizado: {
    label: 'Finalizado',
    style: 'outlined',
    value: 3
  }
}
